import React, { useState } from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { FaSchool, FaTrain, FaShoppingBag, FaBuilding } from "react-icons/fa";
import { GoogleKeys } from "../../../../config/google";

// Dummy Data for Landmarks
const landmarks = [
  {
    category: "Educational Institute",
    icon: <FaSchool size={20} className="text-red-500" />,
    places: [
      "Red Rose International School (1.7 Km)",
      "Dr Radhakrishnan Institute of Tech. (17.1 Km)",
      "Sunrise Public School (3.2 Km)",
      "Greenwood International (4.5 Km)",
    ],
  },
  {
    category: "Transportation Hub",
    icon: <FaTrain size={20} className="text-blue-500" />,
    places: [
      "Bais Godam Railway Station (4.3 Km)",
      "Mansarovar Metro Station (1.7 Km)",
      "Jaipur Junction (7.5 Km)",
    ],
  },
  {
    category: "Shopping Centre",
    icon: <FaShoppingBag size={20} className="text-green-500" />,
    places: [
      "Crystal Mall (5.6 Km)",
      "Mgf Metropolitan (4.7 Km)",
      "Pink Square Mall (8.3 Km)",
      "GT Central Mall (10.1 Km)",
    ],
  },
  {
    category: "Commercial Hub",
    icon: <FaBuilding size={20} className="text-purple-500" />,
    places: [
      "Jcb India Ltd (16.1 Km)",
      "Business Park Tower (6.0 Km)",
      "Corporate World Tower (8.7 Km)",
    ],
  },
];


const iconMap = {
  "Educational Institutes": <FaSchool size={20} className="text-red-500" />,
  "Shopping Centers": <FaShoppingBag size={20} className="text-green-500" />,
  "Public Transport": <FaTrain size={20} className="text-blue-500" />,
  "General Places": <FaBuilding size={20} className="text-purple-500" />,
};



// Google Maps Configuration
const containerStyle = {
  width: "100%",
  height: "250px",
  borderRadius: "10px",
};


const NearbySection = ({ project }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  console.log("projectprojectproject", project)
  const projectLocation = project?.basicDetails?.location;

  const center = {
    lat: projectLocation?.latitude || 26.9124,
    lng: projectLocation?.longitude || 75.7873,
  };


  const landmarks = project?.landmarks || [];

  return (
    <div className="px-4 py-6 mx-6 my-3 rounded bg-white  shadow border border-gray-200">
      {/* Title */}
      <h2 className="text-2xl font-bold mb-4">What's Nearby</h2>

      {/* Google Map */}
      <LoadScript googleMapsApiKey={GoogleKeys.GOOGLE_MAPS_API_KEY}>
        <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={12}>
          <Marker position={center} />
        </GoogleMap>
      </LoadScript>

      {/* Landmarks Section */}
      <h3 className="text-lg font-semibold mt-5 mb-3 capitalize">
        Landmarks near {project?.basicDetails?.projectName || "Project"}
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 relative">
        {landmarks.map((category, index) => (
          <div
            key={index}
            className="relative"
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <div
              className={`px-2 py-2 bg-white rounded-lg shadow border border-gray-200 flex flex-col space-y-2 transition-all duration-300 ${hoveredIndex === index
                ? "absolute left-0 right-0 z-50 w-full bg-white shadow"
                : ""
                }`}
            >
              <div className="flex items-start space-x-3">
                <div>{iconMap[category.category] || <FaBuilding size={20} className="text-gray-500" />}</div>
                <div className="w-full">
                  <h4 className="font-semibold">{category.category}</h4>
                  <ul className="text-gray-700 text-sm mt-1">
                    {category.places
                      .slice(0, hoveredIndex === index ? category.places.length : 2)
                      .map((place, idx) => (
                        <li key={idx} className="flex items-center bg-white whitespace-nowrap">
                          ✅
                          <div className="flex items-center min-w-0">
                            <span className="truncate max-w-[200px] inline-block" title={place?.name}>
                              {place?.name}
                            </span>
                            <span className="font-bold ml-2 flex-shrink-0">({place?.distance} Km)</span>
                          </div>
                        </li>
                      ))}
                  </ul>

                  {/* Show More Indicator - Hidden When Hovered */}
                  {category.places.length > 2 && hoveredIndex !== index && (
                    <p className="text-red-500 text-sm mt-1 cursor-pointer">
                      + {category.places.length - 2} more
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NearbySection;
